import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import propTypes from "prop-types";
import {
  ApplePayContent,
  CreditCardContent,
  SadadPayContent,
  SplitPayContent,
} from "./Tabs";
import PaymentGatewayWrapper from "./PaymentGateway.style";
import TamaraPayIcon from "./Icons/tamara.svg";
import TamaraPayIconAr from "./Icons/tamara-ar.svg";
import SadadPayIcon from "./Icons/Sadad_Payment.svg";
import ApplePayIcon from "./Icons/Apple_Pay.svg";

import {
  BUSINESS_LINE_COLORS,
  BUSINESS_LINE_PATHS,
  isArabic,
} from "../../helpers/utils";

import { useSelector } from "react-redux";

function PaymentGateway(props) {
  const paymentOptions = {
    APPLE: { code: "apple", index: 0, label: "ApplePay" },
    CREDIT_CARD: { code: "cc", index: 1, label: "Credit / Debit Card" },
    TAMARA: { code: "tamara", index: 2, label: "Tamara" },
    SADAD: { code: "sadad", index: 3, label: "Sadad" },
  };

  const [isApplePayAvailable, setIsApplePayAvailable] = useState(false);

  const [activeIndex, setActiveIndex] = useState(
    paymentOptions.CREDIT_CARD.index
  );
  const { isWorldcup, businessLine } = useSelector((state) => state.travel);

  const isWhiteList = (code) => {
    return props.paymentOptions.includes(code);
  };

  useEffect(() => {
    try {
      const paySession = window?.ApplePaySession.canMakePayments();
      console.log("paySession : ", paySession);
      if (paySession) {
        setIsApplePayAvailable(true);
        setActiveIndex(paymentOptions.APPLE.index);
      }
    } catch (error) {
      console.log("ApplePaySession error : ", error);
    }
  }, []);

  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === BUSINESS_LINE_PATHS.STC)
    businessColor = BUSINESS_LINE_COLORS.STC;

  return (
    <PaymentGatewayWrapper
      businessColor={businessColor}
      className={"px-md-0 " + (props.i18n.language === "ar" ? "ar" : "")}
    >
      <div className={"payment-buttons text-initial pt-2 pb-2"}>
        {isWhiteList(paymentOptions.APPLE.code) && isApplePayAvailable && (
          <Button
            label={
              <img
                src={ApplePayIcon}
                alt="Apply Pay"
                height="20px"
                width="60px"
              />
            }
            onClick={() => setActiveIndex(paymentOptions.APPLE.index)}
            className={`payment-option p-button-text mx-3 ${
              activeIndex === 3 ? "active" : ""
            }`}
          />
        )}
        {isWhiteList(paymentOptions.CREDIT_CARD.code) && (
          <Button
            label={props.i18n.t("common.credit-debit-card")}
            icon="pi pi-credit-card"
            onClick={() => setActiveIndex(paymentOptions.CREDIT_CARD.index)}
            className={`payment-option p-button-text mx-3 ${
              activeIndex === paymentOptions.CREDIT_CARD.index
                ? "active"
                : isWorldcup
                ? "worldcup_inactive_btn_color"
                : ""
            }`}
          />
        )}
        {isWhiteList(paymentOptions.TAMARA.code) && props.showTamra
          && (+props.totalAmount > 100 &&
          +props.totalAmount <= 10000 )&& (
            <Button
              label={
                <div className="d-flex align-items-baseline">
                  <img
                    src={
                      isArabic(props.i18n.language)
                        ? TamaraPayIconAr
                        : TamaraPayIcon
                    }
                  />
                </div>
              }
              onClick={() => setActiveIndex(paymentOptions.TAMARA.index)}
              className={`py-1 payment-option tamara  p-button-text mx-3 ${
                activeIndex === paymentOptions.TAMARA.index ? "active" : ""
              }`}
            />
          )}
        {isWhiteList(paymentOptions.SADAD.code) && (
          <Button
            label={
              <img
                src={SadadPayIcon}
                alt="Sadad Pay"
                height="20px"
                width="60px"
              />
            }
            onClick={() => setActiveIndex(paymentOptions.SADAD.index)}
            className={`payment-option p-button-text mx-3 ${
              activeIndex === paymentOptions.SADAD.index ? "active" : ""
            }`}
          />
        )}

        {/* <Button
                    label={<img src={STCPayIcon} alt="STC Pay" height="20px" width="60px" />}
                    onClick={() => setActiveIndex(3)}
                    className={`payment-option p-button-text ml-2 ${(activeIndex === 3) ? 'active' : ''}`}
                /> */}
        {/* <div  id="tamaraWidget" ></div> */}
      </div>

      <Accordion
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
        onTabClose={(e) => {
          if (e.index === activeIndex) {
            setActiveIndex(activeIndex);
          }
        }}
        transitionOptions={{ disabled: true }}
      >
        {isWhiteList(paymentOptions.APPLE.code) && isApplePayAvailable && (
          <AccordionTab
            header={
              <img
                src={ApplePayIcon}
                alt="Apply Pay"
                height="20px"
                width="60px"
              />
            }
            headerClassName="p-d-flex p-ai-center "
          >
            <ApplePayContent applePayHandler={props.applePayHandler} />
          </AccordionTab>
        )}
        {isWhiteList(paymentOptions.CREDIT_CARD.code) && (
          <AccordionTab
            header={
              <>
                <i className="pi pi-credit-card mx-2"></i>
                {props.i18n.t("common.credit-debit-card")}
              </>
            }
            headerClassName="tw-credit-card p-d-flex p-ai-center"
          >
            <CreditCardContent
              creditCardToken={props.creditCardToken}
              acknowledgeAgree={props.ackAgree}
              creditCardLoading={props.creditCardLoading}
            />
          </AccordionTab>
        )}
        {isWhiteList(paymentOptions.TAMARA.code) && props.showTamra &&
          +props.totalAmount > 100 &&
          +props.totalAmount <= 10000 && (
            <AccordionTab
              header={
                <div className="d-flex align-items-baseline">
                  <img
                    className="mt-2"
                    src={
                      isArabic(props.i18n.language)
                        ? TamaraPayIconAr
                        : TamaraPayIcon
                    }
                    alt="tamaraICON"
                  />
                </div>
              }
              headerClassName="p-d-flex p-ai-center"
            >
              <SplitPayContent
                totalAmount={props.totalAmount}
                tamaraCreateSession={props.tamaraCreateSession}
                loading={props.creditCardLoading}
                ackAgree={props.ackAgree}
                optionsTamara={props.optionsTamara}
                splitPayment={props.splitPayment}
                setSplitPayment={props.setSplitPayment}
              />
            </AccordionTab>
          )}
        {isWhiteList(paymentOptions.SADAD.code) && (
          <AccordionTab
            header={
              <img
                src={SadadPayIcon}
                alt="Sadad Pay"
                height="20px"
                width="60px"
              />
            }
            headerClassName="p-d-flex p-ai-center "
          >
            <SadadPayContent
              sadadHandler={props.sadadHandler}
              ackAgree={props.ackAgree}
              loading={props.creditCardLoading}
            />
          </AccordionTab>
        )}
        {/* <AccordionTab
            header={<img src={STCPayIcon} alt="STC Pay" height="20px" width="60px" />}
            headerClassName="p-d-flex p-ai-center ">
            <STCPayContent />
            </AccordionTab> */}
      </Accordion>
    </PaymentGatewayWrapper>
  );
}

PaymentGateway.propTypes = propTypes.exact({
  ackAgree: propTypes.bool.isRequired,
  paymentOptions: propTypes.arrayOf(propTypes.oneOf(["cc", "sadad", "tamara"])),
  creditCardToken: propTypes.func,
  creditCardLoading: propTypes.bool,
  totalAmount: propTypes.number,
  payload: propTypes.exact({
    systemId: propTypes.string.isRequired,
    qoutationNumber: propTypes.string.isRequired,
    idNumber: propTypes.string.isRequired,
    endorsementType: propTypes.string.isRequired,
    mobileNumber: propTypes.string.isRequired,
    email: propTypes.string.isRequired,
    totalAmount: propTypes.string.isRequired,
    successUrl: propTypes.string,
    failedUrl: propTypes.string,
  }).isRequired,
}).isRequired;

export default withTranslation()(PaymentGateway);
